import React from "react";
import styles from "../style/ProgressBar.module.css";

const ProgressBar = ({ percentage }) => {
  return (
    <div className={styles["progress-container"]}>
      <div
        className={styles["progress-bar"]}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
